// src/voicePrompts.js

export const voicePrompts = {
  welcome:
    "Üdvözöllek! Válaszd az új rendelés gombot, vagy ha már van kódod, válaszd a van kódom lehetőséget.",

  startOrder:
    "Rendelés indítása. Válassz méretet a képernyőn.",

  haveCode:
    "Add meg a hat jegyű kódot.",

  chooseProduct:
    "Válassz terméket a képernyőn.",

  chooseCone:
    "Válaszd ki, milyen tölcsért vagy poharat szeretnél.",

  chooseIcecream:
    "Most válaszd ki a fagylalt ízét.",

  chooseSauce:
    "Válassz öntetet, vagy lépj tovább öntet nélkül.",

  chooseTopping:
    "Válassz szórást, vagy lépj tovább szórás nélkül.",

  reviewOrder:
    "Ellenőrizd a rendelésedet, majd nyomd meg a fizetés gombot.",

  scanQr:
    "A fizetéshez olvasd be a képernyőn látható QR kódot a telefonoddal.",

  paymentChecking:
    "Fizetés ellenőrzése folyamatban. Kérlek várj.",

  paymentSuccess:
    "A fizetés sikeres. A rendelésed készítése elindul.",

  robotWorking:
    "Kérlek várj, a gép elkészíti a rendelésedet.",

  receipt:
    "A nyugta készül. Kérlek várj.",

  finished:
    "Elkészült a rendelésed. Köszönjük!",

  offlineCode:
    "Add meg vagy olvasd be a kapott kódot a rendelés indításához.",

  codeChecking:
    "A kód ellenőrzése folyamatban. Kérlek várj.",

  codeAccepted:
    "A kód elfogadva. A robot elindítja a rendelés elkészítését.",

  codeInvalid:
    "A kód nem megfelelő. Ellenőrizd a hat jegyű kódot, majd próbáld újra.",

  error:
    "Hiba történt. Kérlek szólj a kezelőnek."
};
